import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

const isPreview = () =>
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("preview") === "1";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => {
  if (isPreview()) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easing }}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal for headlines
export const MaskLines = ({ lines, className = "", lineClassName = "", start = 0.1 }) => {
  if (isPreview())
    return (
      <span className={className}>
        {lines.map((line, i) => (
          <span key={i} className={`block ${lineClassName}`}>{line}</span>
        ))}
      </span>
    );
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: start + i * 0.12, ease: easing }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
